<template>
  <el-button
    text
    size="default"
    :disabled="disabled"
    class="th:hover:text-th-primary th:hover:bg-th-light-blue new-chat-button"
    data-testid="ai-chat-new-chat-button"
    @click="emit('click')"
  >
    <edit-icon class="shrink-0" />
    <span>{{ t('aichat.main.new_chat') }}</span>
  </el-button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { EditIcon } from '@shared/assets/icons'

withDefaults(
  defineProps<{
    /* an answer is streaming: a new chat waits until it ends */
    disabled?: boolean
  }>(),
  { disabled: false }
)

const emit = defineEmits<{
  click: []
}>()

const { t } = useI18n()
</script>

<style scoped>
.new-chat-button {
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 12.5px;
  font-weight: 500;
}

/* el-button wraps the slot in its own inline-flex span, so the gap goes there */
.new-chat-button :deep(> span) {
  gap: 6px;
}
</style>
